<template>
  <div class="jin-info jin-rili_rate">
    <div class="jin-info_title">
      <h5><i class="ushk-icon ushk-icon_zhexiantu"></i>
        <span>各国/地区央行利率</span>
      </h5>
    </div>
    <div class="jin-info_b" :class="{'hide-border': !border}">
      <div class="jin-rili_rate-wrap">
        <table class="jin-table_body">
          <thead>
            <tr>
              <th><b>央 行</b></th>
              <th><b>利 率</b></th>
              <th><b>发布日期</b></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in rates" :key="index">
              <td><img width="24" height="16" :src="item.flagImgUrl">
                  <span>{{ item.bankName }}</span></td>
              <td>{{ item.interestRate }}%</td>
              <td>{{ item.publishTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      rates: [],
      isShow: false
    }
  },
  mounted () {
    this.getRates()
  },
  methods: {
    getRates () {
      $.getJSON('https://rili.jin10.com/interest_rates.json').done((datas) => {
        this.rates = datas
      })
    }
  }
}
</script>
<style lang="scss">
  .jin-rili_rate{
    margin-bottom: 30px;
    position: relative;
    &-wrap{
      padding-left: 10px;
      padding-right: 10px;
      max-height: 450px;
      overflow: auto;
    }
    .jin-info_b{
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      &.hide-border{
        border: none;
      }
      &.is-show{
        .jin-rili_rate-wrap{
          max-height: 9999px;
        }
        .jin-rili_rate-more{
          display: none;
        }
      }
    }
    .jin-table_body{
      font-size: 12px;
      th{
        background: none;
        border: none;
        color: #f45b42;
      }
      td{
        // padding-left: 0;
        padding-right: 0;
        border: none;
        border-bottom: 1px solid #e1e1e1;
        color: #687c9d;
        img{
          margin-right: 5px;
        }
        &:first-child{
          text-align: left;
        }
      }
      tr{
        &:last-child{
          td{
            border-bottom: none;
          }
        }
      }
      b{
        font-weight: 700;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Rate.vue?39183c3d